module.exports = __webpack_public_path__ + "static/media/computer-guy.7c5d62f4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/computer-guy.png
 ** module id = 431
 ** module chunks = 0
 **/